
export enum UserRole {
    ADMIN = 'admin',
    STAFF = 'staff',
    STUDENT = 'student'
}

export interface UserProfile {
    uid: string;
    email: string;
    displayName: string;
    role: UserRole;
    photoURL?: string;
    classId?: string;
    courseId?: string;
    sessionId?: string;
    phoneNumber?: string;
    createdAt?: number;
}

export interface Class {
    id: string;
    name: string;
    code: string;
    createdBy: string;
    createdAt: number;
}

export interface Course {
    id: string;
    name: string;
    code: string;
}

export interface Session {
    id: string;
    year: string;
}

export interface Subject {
    id: string;
    name: string;
    courseId: string;
    staffId: string;
}

export interface Attendance {
    id: string;
    studentId: string;
    subjectId: string;
    date: string;
    status: 'present' | 'absent';
}

export interface Notification {
    id: string;
    title: string;
    message: string;
    role: UserRole | 'all';
    createdAt: number;
    read: boolean;
}
